<template>
  <page-with-back-btn title="Select Customer" class="page">
    <SelectCustomer />
  </page-with-back-btn>
</template>

<script>
import SelectCustomer from "@/components/point-of-sale/Accounts/SelectCustomer";
import BackNavigationBar from "@/components/layout/navigation/BackNavigationBar";
import PageWithBackBtn from "@/components/layout/utils/PageWithBackBtn";
export default {
  name: "SelectCustomerView",
  components: {PageWithBackBtn, BackNavigationBar, SelectCustomer},
}
</script>

<style lang="scss" scoped>
.page{
  height: 100vh;
  overflow-y: scroll;
}
</style>